import { observer } from "mobx-react";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import PlatformIcon from "../../../Assets/Icons/ONLY RYAN LOGO RED.png";
import HamburgerIcon from "../../../Assets/Icons/hamburger.png";
import MainDrawer from "./sidenav";
import { useEffect, useRef } from "react";
import { portalStore } from "../../../Stores/portal";
import { Badge, MenuItem, Select, TextField } from "@mui/material";
import { authStore } from "../../../App";
import FlashIcon from "../../../Assets/Icons/flash.png";
import { liveScoreStore } from "../../../Stores/liveScoreStore";
import { MultiLiveScoreUpdater } from "../../../MiniComponents/allLiveScore";
import { useNavigate } from "react-router-dom";

const _TopNaviation: React.FC<{}> = ({}) => {
  const navRef = useRef(null);
  useEffect(() => {
    if (navRef.current) {
      // console.log(navRef.current);
      portalStore.navbarHeight = (navRef.current as unknown as any)
        .offsetHeight as number;
      portalStore.portalHeight = window.innerHeight - portalStore.navbarHeight;
      console.log(portalStore);
    }
  }, [navRef]);
  return (
    <Navbar expand="lg" className="bg-body-tertiary" sticky="top" ref={navRef}>
      <Container fluid>
        <div
          style={{
            display: "flex",
            flexFlow: "row",
            justifyContent: "center",
            alignItems: "center",
            gap: 20,
          }}
        >
          <MainDrawer />
          <img src={PlatformIcon} height={40} />
          <StoreSelector />
          <TextField id="filled-basic" label="Search" variant="filled" />
        </div>
        <Navbar.Brand href="#">
          <img
            src={PlatformIcon}
            height={40}
            onClick={() => {
              authStore.signOut();
            }}
          />
        </Navbar.Brand>
      </Container>
    </Navbar>
  );
};

const _BottomStatusBar: React.FC = () => {
  const bottomRef = useRef(null);

  useEffect(() => {
    if (bottomRef.current) {
      portalStore.bottomStatusBarHeight = (bottomRef.current as unknown as any)
        .offsetHeight as number;
      portalStore.portalHeight =
        portalStore.portalHeight - portalStore.bottomStatusBarHeight;

      console.log(`Portal Data: ${portalStore.bottomStatusBarHeight}`);
    }
  }, [bottomRef]);
  return (
    <Container
      fluid
      ref={bottomRef}
      style={{
        padding: "20px",
        boxShadow: "0 -0px 5px 2px rgba(0, 0, 0, 0.05)",
        display: "flex",
        flexFlow: "row",
      }}
    >
      <MultiLiveScoreUpdater />
    </Container>
  );
};

const LiveScoresPopover: React.FC = () => {
  return <></>;
};

const _StoreSelector: React.FC = () => {
  var nav = useNavigate();

  if (authStore.focusedStore === undefined) return <></>;
  return (
    <>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={authStore.focusedStore.storeId}
        onChange={(e) => {
          console.log("Store Changed...", e.target.value);
          if (e.target.value === "new-store") {
            nav("/store/create");
            return;
          }
          authStore.focusedStore = authStore.stores.find((s, i) => {
            return s.storeId === e.target.value;
          });
          console.log("New Store", authStore.focusedStore);
        }}
        style={{ border: "0px solid transparent" }}
      >
        {authStore.stores.map((st, i) => (
          <MenuItem
            value={st.storeId}
            key={i}
            style={{ color: st.storeId === "new-store" ? "tomato" : "black" }}
          >
            {st.storeName}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

const StoreSelector = observer(_StoreSelector);

const TopNaviation = observer(_TopNaviation);
const BottomStatusBar = observer(_BottomStatusBar);
export { TopNaviation, BottomStatusBar };
